import { useQuery } from "@tanstack/react-query";
import { updateServiceTemplate } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Update given serviceTemplate via RCB Service API.
 */ function useServiceTemplateEdit(serviceTemplate) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.editServiceTemplate(serviceTemplate), ({ signal })=>updateServiceTemplate({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            body: {
                serviceTemplate
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: !!serviceTemplate
    });
}
export { useServiceTemplateEdit };
